// extracted by mini-css-extract-plugin
export default {"registrationSuccessWrapper":"Authentication_RecoveryPasswordSuccess_registrationSuccessWrapper__8CdT7","mailIcon":"Authentication_RecoveryPasswordSuccess_mailIcon__5EaDh"};